module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-carousel', {
    attrs: {
      "autoplay": false,
      "indicator-custom": "",
      "indicator-inside": false,
      "overlay": _vm.gallery
    },
    scopedSlots: _vm._u([{
      key: "indicators",
      fn: function(props) {
        return [_c('figure', {
          staticClass: "al image",
          attrs: {
            "draggable": false
          }
        }, [_c('img', {
          attrs: {
            "draggable": false,
            "src": _vm.getImgUrl(props.i),
            "title": props.i
          }
        })])]
      }
    }])
  }, [_vm._l((20), function(item, i) {
    return _c('b-carousel-item', {
      key: i
    }, [_c('a', {
      staticClass: "image ",
      on: {
        "click": function($event) {
          _vm.switchGallery(true)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getImgUrl(i)
      }
    })])])
  }), _vm._v(" "), (_vm.gallery) ? _c('span', {
    staticClass: "modal-close is-large",
    on: {
      "click": function($event) {
        _vm.switchGallery(false)
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48ed9866"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/carousel/examples/ExGallery.vue
// module id = 995
// module chunks = 3 48